import { render, staticRenderFns } from "./OnPlaceAgentEdit.vue?vue&type=template&id=54b96b64&scoped=true"
import script from "./OnPlaceAgentEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./OnPlaceAgentEdit.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OnPlaceAgentEdit.vue?vue&type=style&index=0&id=54b96b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b96b64",
  null
  
)

export default component.exports